import React, { ReactNode, useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import Heading from '@atlaskit/heading';
import Tooltip from '@atlaskit/tooltip';

import {
  getPullRequestAttributes,
  publishPrAnalyticsFileViewFolder,
} from 'src/sections/repository/sections/pull-request/hooks/analytics';

import * as styles from './styled';

export type DirectoryProps = {
  children: ReactNode;
  defaultCollapsed?: boolean;
  name: string;
  fileCount: number;
  isLastDir?: boolean;
};

export const FileListDirectory = ({
  children,
  defaultCollapsed = false,
  name,
  fileCount,
  isLastDir = false,
}: DirectoryProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const prAttributes = useSelector(getPullRequestAttributes);

  const toggleDirectory = useCallback(() => {
    setIsCollapsed(!isCollapsed);
    publishPrAnalyticsFileViewFolder(prAttributes, name, !isCollapsed);
  }, [isCollapsed, prAttributes, name]);

  return (
    <styles.Directory isLastDir={isLastDir}>
      <styles.TooltipWrapper>
        <Tooltip position="left" content={name}>
          <styles.DirectoryHeader
            onClick={toggleDirectory}
            onMouseDown={e => e.preventDefault()}
          >
            <styles.DirectoryText isCollapsed={isCollapsed}>
              <Heading level="h200" as="span">
                {isCollapsed && fileCount ? `${name} (${fileCount})` : name}
              </Heading>
            </styles.DirectoryText>
          </styles.DirectoryHeader>
        </Tooltip>
      </styles.TooltipWrapper>
      {!isCollapsed && (
        <styles.DirectoryContent role="list">
          {children}
        </styles.DirectoryContent>
      )}
    </styles.Directory>
  );
};
